module.exports = __webpack_public_path__ + "static/media/close-dark-icon.a7a2126e.svg";